import moment from "moment";
import { IsoDate } from "PFTypes/date_time";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useDateFormatter } from "./use_date_formatter";

export const useRelativeDateFormat = () => {
  const { formatDate } = useDateFormatter();
  const { t } = useTranslation("core");

  return useCallback(
    (date: IsoDate): string => {
      const dateMoment = moment(date);
      if (dateMoment.isSame(moment(), "day")) {
        return t("time.inWords.today");
      }
      if (dateMoment.isSame(moment().subtract(1, "day"), "day")) {
        return t("time.inWords.yesterday");
      }
      return formatDate(date);
    },
    [formatDate, t]
  );
};
